// extracted by mini-css-extract-plugin
module.exports = {"theme":"#b7251e"};